import { responsiveVariables } from "../../utilities/props.js";
import "./padding.css";
const getPaddingStyles = (value) => {
    if (!value)
        return null;
    const variables = responsiveVariables("--rs-p", value);
    return { variables };
};
export default getPaddingStyles;
